export default "__VITE_ASSET__C$KY53Sp__"